import { useState } from 'react';
import { ConfirmDialog } from '@roc/ui';
import { LenderService } from 'libs/feature-app-core/src/services/lenderService';

interface UseEnableExternalCapitalDialogProps {
  lenderId: number;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
}

export const useEnableExternalCapitalDialog = ({
  lenderId,
  onSuccess,
  onError,
}: UseEnableExternalCapitalDialogProps) => {
  const [showDialog, setShowDialog] = useState(false);
  const [lenderService] = useState(() => new LenderService());

  const openDialog = () => setShowDialog(true);
  const closeDialog = () => setShowDialog(false);

  const handleConfirm = async () => {
    try {
      await lenderService.enablePlatformLoanSubmissionFeature(lenderId);
      onSuccess('External Capital feature enabled successfully');
      closeDialog();
      window.location.reload();
    } catch (error) {
      onError('Failed to enable External Capital feature');
      closeDialog();
    }
  };

  const dialog = (
    <ConfirmDialog
      open={showDialog}
      title="Enable External Capital Platform?"
      body={
        <div style={{ maxWidth: '700px', padding: '4px 0' }}>
          You're about to enable access to loans from third-party capital
          providers. This will update your experience in the portal. <br />
          Do you want to continue?
        </div>
      }
      confirmButtonText="CONFIRM"
      cancelButtonText="CANCEL"
      handleClose={closeDialog}
      handleCancel={closeDialog}
      handleConfirm={handleConfirm}
    />
  );

  return {
    enableExternalCapitalDialog: dialog,
    openEnableExternalCapitalDialog: openDialog,
  };
};
